// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"loudspeaker"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9 7H3V12.5H9L15 15V4L9 7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M3 21V12.5H7L6 21H3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 12.5V7H9L15 4V15L9 12.5H3ZM3 12.5V21H6L7 12.5H3ZM6.85 16H8.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M18.25 8.66895C18.9403 9.35927 18.9403 10.4785 18.25 11.1688M20.3335 7C21.7142 8.38066 21.7142 11.453 20.3335 12.8336","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-loudspeaker')
export default class LoudspeakerIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'loudspeaker',
    }
  }
}
